import React from 'react'
import getRunsPerOver from '../util/getRunsPerOver';
import Manhattan from '../components/charts/Manhattan';
import Worm from '../components/charts/Worm';
import './Charts.scss';
import useTranslation from '../useTranslation'

export default function Charts({ scoreboard, teams, scoregrid, event_scoreboard, backgroundColor, foregroundColor }) {

    const ManhattanLabel = useTranslation('Manhattan')
    const WormLabel = useTranslation('Worm')
    const OversLabel = useTranslation('Overs')

    function getValueFromScoreboard(name) {
        let found;

        try {
            found = scoreboard[name]
        } catch (error) {
            console.log("Missing scoreboard field: ", name)
            return null;
        }

        if (! found) {
            return null;
        }

        return found;
    }

    if (! teams || ! event_scoreboard) {
        return (
            <div className="charts">
                Innings yet to start
            </div>
        )
    }

    const { overs } = scoregrid || {};

    const innings1battingteam = getValueFromScoreboard('innings1battingteam')
    const innings2battingteam = getValueFromScoreboard('innings2battingteam')

    let innings1colour, innings2colour;

    const innings1team = teams.find(({ name }) => name === innings1battingteam)
    if (innings1team) {
        innings1colour = innings1team.colour;
    }

    const innings2team = teams.find(({ name }) => name === innings2battingteam)
    if (innings2team) {
        innings2colour = innings2team.colour;
    }

    const runsPerOver = getRunsPerOver(overs);

    // Show minimum 20 overs even if they haven't been played yet
    if (runsPerOver.length < 20) {
        for (let i = runsPerOver.length + 1; i <= 20; i++) {
            runsPerOver.push({
                over: `${i}`,
                innings1Runs: 0,
                innings2Runs: 0,
                innings1Wickets: 0,
                innings2Wickets: 0,
            })
        }
    }

    return (
        <div className="charts">
            <div>
                <div className="chart-name" style={{
                    backgroundColor: foregroundColor,
                    color: backgroundColor
                }}>{ManhattanLabel}</div>
                <Manhattan
                    data={ runsPerOver }
                    innings1battingteam={ innings1battingteam }
                    innings2battingteam={ innings2battingteam }
                    innings1colour={ innings1colour }
                    innings2colour={ innings2colour }
                    foregroundColor={ foregroundColor }
                    oversLabel={OversLabel}
                />
            </div>
            <div>
                <div className="chart-name" style={{
                    backgroundColor: foregroundColor,
                    color: backgroundColor
                }}>{WormLabel}</div>
                <Worm
                    data={ runsPerOver }
                    innings1battingteam={ innings1battingteam }
                    innings2battingteam={ innings2battingteam }
                    innings1colour={ innings1colour }
                    innings2colour={ innings2colour }
                    foregroundColor={ foregroundColor }
                    oversLabel={OversLabel}
                />
            </div>
        </div>
    )
}
